export const routes = [
  {
    path: "/gestao-territorios/:tab",
    component: () => import(/* webpackChunkName: "tema" */ "./components/List"),
    name: "gestao-territorios.list",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/gestao-territorios/:tab/:id",
    component: () =>
      import(/* webpackChunkName: "tema" */ "./components/Insert"),
    name: "gestao-territorios.insert",
    meta: {
      requiresAuth: true,
    },
  },
];
